import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { StateService } from '@uirouter/core';
import { ScrollingListService } from 'src/app/ajs-upgraded-providers';
import { EditorService } from '../../services/editor.service';
import { TemplateApiService } from 'src/app/api/services/template-api.service';
import { TemplatesService } from 'src/app/presentations/services/templates.service';

@Component({
  selector: 'weekly-templates',
  templateUrl: './weekly-templates.component.html',
  styleUrls: ['./weekly-templates.component.scss'],
  standalone: false,
})
export class WeeklyTemplatesComponent implements OnInit {
  weeklyTemplates: any;
  selectedDate: Date | null;
  datesAvailable: boolean = false;

  search = {
    count: 250,
    sort: 'templateCalendarStartDate asc',
    onListUpdate: () => {
      this.changeDetectorRef.detectChanges();
    },
  };

  @ViewChild('weeklyTemplatesContainer') weeklyTemplatesContainer: ElementRef;

  constructor(
    public templatesService: TemplatesService,
    public editorService: EditorService,
    private ScrollingListService: ScrollingListService,
    private templateApiService: TemplateApiService,
    private changeDetectorRef: ChangeDetectorRef,
    public stateService: StateService,
  ) {}

  ngOnInit(): void {
    this.weeklyTemplates = this.ScrollingListService(
      this.loadTemplates.bind(this),
      this.search,
    );
  }

  loadTemplates(search, cursor) {
    if (this.templatesService.upcomingEvents.length) {
      this.datesAvailable = true;
      return Promise.resolve({
        items: this.templatesService.upcomingEvents.slice(0, 3),
      });
    } else {
      return this.templateApiService
        .listTemplates(search, cursor)
        .then((result) => {
          this.datesAvailable = this.templatesService.loadDates(result.items);
          this.templatesService.loadUpcomingEvents(4);
          return {
            items: this.templatesService.upcomingEvents.slice(0, 3),
          };
        });
    }
  }

  select(product: any) {
    this.editorService.addFromProduct(product, {
      addedFrom: 'Events Calendar',
    });
  }

  openLibrary() {
    const params: any = {};
    if (this.selectedDate) {
      params.selectedDate = this.selectedDate.toISOString();
    }
    this.stateService.go('apps.editor.create', params);
    this.selectedDate = null;
  }

  onCalendarResize(event: { width: number; height: number }) {
    if (this.weeklyTemplatesContainer) {
      this.weeklyTemplatesContainer.nativeElement.style.setProperty(
        '--calendar-height',
        event.height + 'px',
      );
    }
  }
}
